/**
 * @generated SignedSource<<db2993f49db101be065872152d4bcf3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasActiveStorageConditions"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "periods"
},
v2 = [
  {
    "kind": "Variable",
    "name": "hasActiveStorageConditions",
    "variableName": "hasActiveStorageConditions"
  },
  {
    "kind": "Variable",
    "name": "periods",
    "variableName": "periods"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hafasId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zip",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openingHoursText",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "OpeningHours",
  "kind": "LinkedField",
  "name": "openingHours",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "from",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "until",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "TerminalInfo",
  "kind": "LinkedField",
  "name": "info",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latitude",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "longitude",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "additionalText",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phone",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "TerminalAgency",
  "kind": "LinkedField",
  "name": "agency",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v6/*: any*/),
    (v8/*: any*/),
    (v7/*: any*/),
    (v9/*: any*/),
    (v15/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneCountryCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "phoneAreaCode",
    "storageKey": null
  },
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v9/*: any*/),
  (v10/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "TerminalBookingOffice",
  "kind": "LinkedField",
  "name": "primaryBookingOffice",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "TerminalBookingOffice",
  "kind": "LinkedField",
  "name": "secondaryBookingOffice",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "TerminalFacilityInfo",
  "kind": "LinkedField",
  "name": "facilityInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dangerousGoodsAllowed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dangerousGoodsText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dangerousGoodsStorageAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parkingPossible",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parkingText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "repairService",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cleaning",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reeferPlugsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customsOnSite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customsText",
      "storageKey": null
    },
    (v15/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TerminalsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Terminal",
        "kind": "LinkedField",
        "name": "terminals",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v16/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TerminalsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Terminal",
        "kind": "LinkedField",
        "name": "terminals",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Country",
            "kind": "LinkedField",
            "name": "country",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/),
          (v16/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d10891f05e58ea2518e3610bd93e0c52",
    "id": null,
    "metadata": {},
    "name": "TerminalsQuery",
    "operationKind": "query",
    "text": "query TerminalsQuery(\n  $periods: [Int!]\n  $hasActiveStorageConditions: Boolean\n) {\n  terminals(periods: $periods, hasActiveStorageConditions: $hasActiveStorageConditions) {\n    id\n    name\n    hafasId\n    country {\n      name\n      id\n    }\n    info {\n      latitude\n      longitude\n      address\n      country\n      zip\n      city\n      openingHoursText\n      additionalText\n      openingHours {\n        text\n        from\n        until\n      }\n    }\n    agency {\n      title\n      email\n      phone\n      address\n      city\n      zip\n      openingHoursText\n      notes\n      openingHours {\n        text\n        from\n        until\n      }\n    }\n    primaryBookingOffice {\n      phoneCountryCode\n      phoneAreaCode\n      title\n      email\n      phone\n      notes\n      openingHoursText\n      openingHours {\n        text\n        from\n        until\n      }\n    }\n    secondaryBookingOffice {\n      phoneCountryCode\n      phoneAreaCode\n      title\n      email\n      phone\n      notes\n      openingHoursText\n      openingHours {\n        text\n        from\n        until\n      }\n    }\n    facilityInfo {\n      dangerousGoodsAllowed\n      dangerousGoodsText\n      dangerousGoodsStorageAvailable\n      parkingPossible\n      parkingText\n      repairService\n      cleaning\n      reeferPlugsAvailable\n      customsOnSite\n      customsText\n      notes\n    }\n  }\n}\n"
  }
};
})();

node.hash = "372e460021e6ff7c3a2db2bf52503ea6";

module.exports = node;
